var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeyboardDoubleArrowRight24Dp5F6368Fill0Wght400Grad0Opsz24 = function SvgKeyboardDoubleArrowRight24Dp5F6368Fill0Wght400Grad0Opsz24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#5f6368",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M383-480 200-664l56-56 240 240-240 240-56-56zm264 0L464-664l56-56 240 240-240 240-56-56z"
  })));
};
export default SvgKeyboardDoubleArrowRight24Dp5F6368Fill0Wght400Grad0Opsz24;